import { v4 as uuidv4 } from "uuid";
/**
 * Read — or create on first use — the stable per-document UUID stored as the
 * Word custom document property "DocumentID".
 *
 * This is a one-time async read: the value is fixed for the lifetime of the
 * document, so it is a plain function (resolve once, write to the session
 * store), not a hook. The backend uses it to identify the Word document.
 */ export async function getOrCreateDocId() {
    return Word.run(async (context)=>{
        const customProps = context.document.properties.customProperties;
        customProps.load("items");
        await context.sync();
        const existingProp = customProps.items.find((p)=>p.key === "DocumentID");
        if (existingProp) {
            return existingProp.value;
        }
        const newId = uuidv4();
        customProps.add("DocumentID", newId);
        await context.sync();
        return newId;
    });
}
